import { ReportingStatus } from 'api/services';
import * as S from './styles';
import { getHumanizedStatus } from './utils';

export interface CampaignReportingStatusProps {
  status?: ReportingStatus | null;
}

const CampaignReportingStatus: React.FC<CampaignReportingStatusProps> = ({
  status,
}) => {
  if (!status) {
    return null;
  }

  return (
    <S.StatusTypography variant="caption" $status={status}>
      {getHumanizedStatus(status)}
    </S.StatusTypography>
  );
};

export default CampaignReportingStatus;
